import { Permission } from '.';

export interface PermissionViewProps {
  children: React.ReactElement;
  oneOf?: SamadRole[];
  required?: SamadRole | SamadRole[];
}

export default function PermissionView({
  children,
  oneOf,
  required
}: PermissionViewProps) {
  return (
    <Permission oneOf={oneOf} required={required} fallbackView={<></>}>
      {children}
    </Permission>
  );
}
